import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lead: null,
    reseller: null,
  },
  mutations: {
    setLead(state, response) {
      state.lead = response;
    },
    setReseller(state, response) {
      state.reseller = response;
    },
  },
  actions: {
    setLead({ commit }, params) {
      commit('setLead', params.lead);
      commit('setReseller', params.reseller);
    },
  },
});

export default store;